import { useQuery } from '@tanstack/react-query';
import { adminsService } from '../data/admins.service';

export const useAdmins = () => {
    return useQuery({
        queryKey: ['admins'],
        queryFn: () => adminsService.getAdmins()
    });
};

export const useRoles = () => {
    return useQuery({
        queryKey: ['roles'],
        queryFn: () => adminsService.getRoles()
    });
};

export const useWhitelistedIps = () => {
    return useQuery({
        queryKey: ['whitelisted_ips'],
        queryFn: () => adminsService.getWhitelistedIps()
    });
};
